export const BANKS_CHILE = [
  'Banco de Chile',
  'Banco del Estado de Chile (BancoEstado)',
  'Banco Santander Chile',
  'Scotiabank Chile',
  'Banco de Crédito e Inversiones (BCI)',
  'Banco Bice',
  'Banco Security',
  'Banco Falabella',
  'Banco Ripley',
  'Banco Consorcio',
  'Banco Internacional',
  'Banco Itaú Chile',
  'Banco BTG Pactual Chile',
  'HSBC Bank (Chile)',
  'Tanner Banco Digital',
  'JP Morgan Chase Bank (Sucursal Chile)',
  'China Construction Bank (Agencia en Chile)',
  'Bank of China (Agencia en Chile)',
];

export const BANKS_PERU = [
  'Banco de Comercio',
  'Banco de Crédito del Perú (BCP)',
  'BanBif (Banco Interamericano de Finanzas)',
  'Banco Pichincha',
  'BBVA',
  'Citibank Perú',
  'Compartamos Banco',
  'Interbank',
  'Mibanco',
  'Scotiabank Perú',
  'Banco GNB Perú',
  'Banco Falabella',
  'Banco Ripley',
  'Banco Santander Perú',
  'Alfin Banco',
  'Bank of China',
  'Bci Perú',
  'ICBC Peru Bank',
  'Santander Consumer Bank',
  'Banco de la Nación',
  'Agrobanco',
  'COFIDE',
];

export const BANKS_ECUADOR = [
  'Banco Pichincha',
  'Banco Guayaquil',
  'Produbanco',
  'Banco del Pacífico',
  'Banco Internacional',
  'Banco Bolivariano',
  'Banco de Loja',
  'Banco Rumiñahui',
  'Banco General Rumiñahui',
];

export const BANKS_PANAMA = ['Yappi'];

export const BANKS_COLOMBIA = [
  { code: '1558', name: 'BAN100' },
  { code: '1059', name: 'BANCAMIA S.A.' },
  { code: '1040', name: 'BANCO AGRARIO' },
  { code: '1052', name: 'BANCO AV VILLAS' },
  { code: '1013', name: 'BANCO BBVA COLOMBIA S.A.' },
  { code: '1032', name: 'BANCO CAJA SOCIAL' },
  { code: '1066', name: 'BANCO COOPERATIVO COOPCENTRAL' },
  { code: '1051', name: 'BANCO DAVIVIENDA' },
  { code: '1001', name: 'BANCO DE BOGOTA' },
  { code: '1023', name: 'BANCO DE OCCIDENTE' },
  { code: '1062', name: 'BANCO FALABELLA' },
  { code: '1063', name: 'BANCO FINANDINA S.A. BIC' },
  { code: '1012', name: 'BANCO GNB SUDAMERIS' },
  { code: '1006', name: 'BANCO ITAU' },
  { code: '1060', name: 'BANCO PICHINCHA S.A.' },
  { code: '1002', name: 'BANCO POPULAR' },
  { code: '1065', name: 'BANCO SANTANDER COLOMBIA' },
  { code: '1069', name: 'BANCO SERFINANZA' },
  { code: '1303', name: 'BANCO UNION antes GIROS' },
  { code: '1007', name: 'BANCOLOMBIA' },
  { code: '1061', name: 'BANCOOMEVA S.A.' },
  { code: '1283', name: 'CFA COOPERATIVA FINANCIERA' },
  { code: '1009', name: 'CITIBANK' },
  { code: '1370', name: 'COLTEFINANCIERA' },
  { code: '1292', name: 'CONFIAR COOPERATIVA FINANCIERA' },
  { code: '1291', name: 'COOFINEP COOPERATIVA FINANCIERA' },
  { code: '1289', name: 'COTRAFA' },
  { code: '1097', name: 'DALE' },
  { code: '1551', name: 'DAVIPLATA' },
  { code: '1637', name: 'IRIS' },
  { code: '1070', name: 'LULO BANK' },
  { code: '1801', name: 'MOVII S.A.' },
  { code: '1507', name: 'NEQUI' },
  { code: '1811', name: 'RAPPIPAY' },
  { code: '1019', name: 'SCOTIABANK COLPATRIA' },
  { code: '1804', name: 'UALÁ' },
  { code: '1803', name: 'POWWI' },
  { code: '1809', name: 'NU' },
  { code: '1815', name: 'ALIANZA FIDUCIARIA' },
  { code: '1111', name: 'Banco Cooperativo Coopcentral' },
  { code: '1808', name: 'Bold CF' },
  { code: '1814', name: 'Banco Global66' },
  { code: '1560', name: 'Banco Pibank' },
  { code: '1071', name: 'Banco GNB Sudameris' },
];